import React, { useEffect, useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { getUser } from '../services/userService';
// import { hasActiveSubscription } from '../services/stripeService';
import { Card, Alert, Spinner, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
// import { getStatusBadgeVariant, isActiveSubscription } from '../utils/subscriptionUtils';

const SuccessPage = () => {
  const { user, userData, setUserData } = useUser();
  const [loading, setLoading] = useState(true);
  const [refreshed, setRefreshed] = useState(false);
  // const [subscriptionActive, setSubscriptionActive] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const refreshUserData = async () => {
      if (user && !refreshed) {
        try {
          // Wait a moment for webhook to process
          await new Promise(resolve => setTimeout(resolve, 3000));
          
          // Get fresh user data
          const freshUserData = await getUser(user.uid);
          setUserData(freshUserData);
          
          // Test subscription status - COMMENTED OUT
          // const hasActive = await hasActiveSubscription();
          // setSubscriptionActive(hasActive);
          
          setRefreshed(true);
        } catch (error) {
          console.error('Error refreshing user data:', error);
          setError('Failed to refresh user data. Please try again later.');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    refreshUserData();
  }, [user, refreshed, setUserData]);

  if (loading) {
    return (
      <>
        <SEO
          title="Payment Success - Osailu"
          description="Your payment has been processed successfully."
          url="/success"
          noindex={true}
        />
        <div style={{ 
          minHeight: 'calc(100vh - 120px)', 
          backgroundColor: 'var(--bg-color)',
          color: 'var(--text-color)',
          transition: 'background-color 0.3s ease, color 0.3s ease',
          padding: '20px 0'
        }}>
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <Card>
                <Card.Body className="text-center">
                  <Spinner animation="border" className="mb-3" />
                  <h5>Processing your payment...</h5>
                  <p className="text-muted">Please wait while we confirm your payment.</p>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEO
        title="Payment Success - Osailu"
        description="Your payment has been processed successfully."
        url="/success"
        noindex={true}
      />
      <div style={{ 
        minHeight: 'calc(100vh - 120px)', 
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        padding: '20px 0'
      }}>
      <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <Card>
            <Card.Header>
              <h4 className="mb-0">
                ✅ Payment Processed
              </h4>
            </Card.Header>
            <Card.Body>
              {error && (
                <Alert variant="warning" className="mb-4">
                  <Alert.Heading>Verification Issue</Alert.Heading>
                  <p>{error}</p>
                </Alert>
              )}
              
              <Alert variant="info" className="mb-4">
                <Alert.Heading>Thank you for your purchase!</Alert.Heading>
                <p>
                  Your payment has been processed successfully.
                </p>
              </Alert>

              {/* Commented out: Subscription details display */}
              {/* {userData && (
                <div className="mb-4">
                  <h5>Subscription Details</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Status:</strong> 
                        <Badge bg={getStatusBadgeVariant(userData.subscriptionStatus)} className="ms-2">
                          {userData.subscriptionStatus}
                        </Badge>
                      </p>
                      <p><strong>Email:</strong> {userData.email}</p>
                    </div>
                    <div className="col-md-6">
                      {userData.currentPeriodEnd && (
                        <p><strong>Next Billing:</strong> {new Date(userData.currentPeriodEnd).toLocaleDateString()}</p>
                      )}
                      {userData.stripeCustomerId && (
                        <p><strong>Customer ID:</strong> <small className="text-muted">{userData.stripeCustomerId}</small></p>
                      )}
                    </div>
                  </div>
                </div>
              )} */}

              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <Button 
                  variant="primary" 
                  onClick={() => navigate('/')}
                >
                  Go to Dashboard
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};

export default SuccessPage;
